import { render } from "./TestcaseDiff.vue?vue&type=template&id=1f9abc3b&scoped=true"
import script from "./TestcaseDiff.vue?vue&type=script&lang=js"
export * from "./TestcaseDiff.vue?vue&type=script&lang=js"

import "./TestcaseDiff.vue?vue&type=style&index=0&id=1f9abc3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9abc3b"]])

export default __exports__